import * as queryString from "query-string"

type ExternalService = {
  congestionKey: string | null
  restroomIds: string[]
}

/**
 * externalId内の各値を指すkey値の対応表
 */
enum ExternalIdKey {
  CONGESTION_KEY = "co", // 混雑状況
  RESTROOM_ID = "rr", // トイレ空室管理
}

/**
 * Mappedin location can have external id string as a property.
 * Currently we support congestion system and restroom system to connect them to
 * locations.
 * Extenal id must be the format.
 * co=[CONGESTION_SYSTEM_KEY]&rr=[ARRAY_OF_RESTROOM_PLACEMENT_IDS]
 * e.g. co=d0c41381f5568583206a7950b0428dc9168a99398e982e272bd0df04d18eb7f4&rr=123,456
 */
export function parseExternalId (externalId: string): ExternalService {
  const parsed = queryString.parse(externalId, { arrayFormat: "comma", })
  const parsedCo = parsed[ExternalIdKey.CONGESTION_KEY]
  const parsedRr = parsed[ExternalIdKey.RESTROOM_ID]
  let congestionKey = null
  if (parsedCo) {
    if (typeof parsedCo === "string") {
      congestionKey = parsedCo
    } else if (Array.isArray(parsedCo) && parsedCo[0]) {
      congestionKey = parsedCo[0]
    }
  }
  let restroomIds: string[] = []
  if (parsedRr) {
    if (typeof parsedRr === "string") {
      restroomIds.push(parsedRr)
    } else if (Array.isArray(parsedRr)) {
      restroomIds = parsedRr
    }
  }
  return {
    congestionKey,
    restroomIds,
  }
}
